import classNames from "classnames";
import { HTMLProps } from "react";
import { Control, Controller } from "react-hook-form";
import styles from "./radio-button.module.scss";

type Props = {
  name: string;
  options: { label: string; value: string }[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
} & HTMLProps<HTMLInputElement>;

export const RadioButton = ({
  name,
  options,
  className,
  control,
  ...inputProps
}: Props) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        const error = errors[name]?.message as string;
        return (
          <div className={classNames(styles.radioGroup, className)}>
            {options.map((option) => (
              <label
                key={option.value}
                className={classNames(
                  styles.radioLabel,
                  value === option.value && styles.activeRadioLabel
                )}
              >
                <input
                  type="radio"
                  className={styles.radioInput}
                  value={option.value}
                  checked={value === option.value}
                  onChange={() => onChange(option.value)}
                  {...inputProps}
                />
                <span className={styles.radioCustom} />
                {option.label}
              </label>
            ))}
            {error && <span className={styles.error}>{error}</span>}
          </div>
        );
      }}
    />
  );
};
